/**
 * OEM Organization metadata for AI-Manual.
 *
 * The currently authenticated User belongs to an Organization (default: 'default'
 * with brand_name='AI-Manual', primary_color='#1976D2'). We expose the data
 * here so AppBar / NavigationDrawer / public-facing pages can pick the
 * brand logo, brand name, and primary color without refetching.
 *
 * The data is sourced from /api/auth/account-detail/ (handled in authStore;
 * this store derives + exposes the relevant slice).
 */
import { defineStore } from "pinia";
import { computed } from "vue";

import { useAuthStore } from "./authStore";

const DEFAULT_ORGANIZATION = {
  slug: "default",
  brand_name:
    import.meta.env.VITE_BRAND_NAME || "Qumowill AI Manual",
  logo_url: "",
  primary_color:
    import.meta.env.VITE_PRIMARY_COLOR || "#1976D2",
  custom_domain: "",
};

export const useOrganizationStore = defineStore("organization", () => {
  const authStore = useAuthStore();

  const organization = computed(() => {
    return authStore.userProfile?.organization || DEFAULT_ORGANIZATION;
  });

  const brandName = computed(() => organization.value.brand_name);
  const logoUrl = computed(() => organization.value.logo_url || "");
  const primaryColor = computed(() => organization.value.primary_color);
  const slug = computed(() => organization.value.slug);

  return {
    organization,
    brandName,
    logoUrl,
    primaryColor,
    slug,
  };
});
